module.exports = __webpack_public_path__ + "img/smart-city-inicial-min.38d832a0.png";